export default __webpack_public_path__ + "static/BackgroundSwooshBlack-c3b9b06ac566a089bfd9da3113608abd.png";